import { ComponentType } from '../table_component'
import { Schema } from '../types'

export const otherViewSchema: Schema = {
  title: 'Config Change Audit',
  level: 1,
  columns: [
    {
      id: 'note',
      name: 'Note',
      component: ComponentType.Text
    }
  ]
}
